import { QueryClient } from "@tanstack/react-query";

import { shouldReportError } from "@/shared/http/shouldReportError";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Our HttpClient already retries requests
      retry: false,

      // Default stale time of 5 minutes
      staleTime: 1000 * 60 * 5,
    },
    mutations: {
      onError: (err, variables) => {
        // Expected, user-resolvable failures (e.g. a dashboard revision
        // conflict) have their own UI and are not defects — reporting them
        // would bury real failures in noise.
        if (shouldReportError(err)) {
          ErrorMonitoringService.captureError(err, { variables });
        }
      },
    },
  },
});
